<template>
    <el-dialog title="建设单位管理" :visible.sync="show" width="600px"
               append-to-body @close="close">
        <div class="dialog_content">
            <div class="list" v-if="developer_list?.length>0">
                <div class="item" v-for="(v,k) in developer_list" :key="'developer_list'+k">
                    <div class="item_row">
                        <div class="label">单位名称</div>
                        <div class="name value" v-if="!v.is_edit">
                            <span class="text">{{ v.construction_unit }}</span>
                            <span class="edit_icon el-icon-edit-outline" @click="openEdit(v)"></span>
                        </div>
                        <el-input v-else v-model="v.edit_name" :id="v.id||'add_input'"
                                  :disabled="is_save" placeholder="请输入单位名称" size="small"
                                  @blur="save(v,k)" @keyup.enter.native="$event&&$event.target&&$event.target.blur()"
                        ></el-input>
                    </div>
                    <div class="item_row">
                        <div class="label">负责人</div>
                        <div class="users value">
                            <div class="nickname" v-for="(user,index) in v.users" :key="'users'+index">
                                <div class="text">{{user.nickname}}</div>
                                <div class="del_user" @click="deleteUser(v,user)">
                                    <span class="el-icon-close"></span>
                                </div>
                            </div>
                            <div class="add_btn">
                                <el-button plain size="mini" icon="el-icon-plus" circle
                                           @click="chooseUsers(v)"></el-button>
                            </div>
                        </div>
                    </div>
                    <div class="delete_icon" @click="deleteItem(v)" v-if="v?.id">
                        <span class="el-icon-delete"></span>
                    </div>
                </div>
            </div>
            <div class="add_item" @click="openAdd">
                <span class="icon el-icon-plus"></span>
                <span class="text">添加建设单位</span>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import {ref, watch, nextTick} from 'vue';
import api from '@/api/methods/index'
import {Message, MessageBox} from "element-ui";
import peoplePicker from '@/utils/people_picker';
import store from '@/vuex/index';

const props = defineProps({
    showDeveloper: {
        type: Boolean,
        default: false,
    }
})

const emits = defineEmits(['update:showDeveloper', 'refresh'])

let show = ref(false);
let developer_list = ref([
    // {
    //     id: '',//没有的话为新建
    //     construction_unit: '',//单位名称
    //     is_edit: false,//是否在编辑中
    //     edit_name: '',//修改成功后改为与name一样的名称,用于判断是否已修改
    //     users: [],//建设单位负责人
    // }
]);
let is_save = ref(false);//保存中

function syncCurrentUserContractInfoByList() {
    let current_user = store.state.user.current_user || {};
    if (!current_user?.userid) {
        return;
    }
    let new_user = JSON.parse(JSON.stringify(current_user));
    let contract_info = null;
    developer_list.value.some(item => {
        let match = (item.users || []).find(user => `${user.userid}` === `${current_user.userid}`);
        if (!match) {
            return false;
        }
        contract_info = {
            userid: current_user.userid,
            record_id: match.data_id || '',
            construction_unit: item.construction_unit || '',
            construction_id: item.id || ''
        };
        return true;
    });
    new_user.contract_info = contract_info;
    store.commit('user/SETCURRENTUSER', new_user);
}

//点击添加
function openAdd() {
    let i = developer_list.value.findIndex(a => !a.id)
    if (i === -1) {
        developer_list.value.push({
            construction_unit: '',
            is_edit: true,
            edit_name: '',
        })
        nextTick(() => {
            let dom = document.getElementById('add_input')
            if (dom) {
                dom.focus();
            }
        })
    }
}

//点击修改
function openEdit(item) {
    item.edit_name = item.construction_unit;
    item.is_edit = true;
    nextTick(() => {
        let dom = document.getElementById(item.id)
        if (dom) {
            dom.focus();
        }
    })
}

//触发新增或修改
async function save(item, index) {
    if (is_save.value) {
        return;
    }
    let param = {
        construction_unit: item.edit_name,
        status: 1
    }
    let other_names = developer_list.value.filter(a => a?.id && a.id !== item.id).map(a => a?.construction_unit)
    let i = other_names.indexOf(item.edit_name);
    if (item.id) {//编辑
        //修改值为空 或 未修改
        if (!item.edit_name || item.edit_name === item.construction_unit || i !== -1) {
            if (i !== -1) {
                Message({message: '不能设置重复名称!', type: 'warning'});
            }
            item.is_edit = false;
            return;
        }
        param.id = item.id
    } else {//新增
        //新增值为空
        if (!item.edit_name || i !== -1) {
            if (i !== -1) {
                Message({message: '不能设置重复名称!', type: 'warning'});
            }
            developer_list.value.splice(index, 1)
            return;
        }
    }
    is_save.value = true;
    let res = await api.contract.SaveConstruction(param)
    if (res?.data?.state == 1) {
        Message({message: '保存成功!', type: 'success'});
        emits('refresh')
    }
    is_save.value = false;
    await getList();
}

//人员变更api调用, item: 建设单位信息, user:人员信息
async function userChange(item, user) {
    let param = {
        construction_id: item.id,
        userid: user.userid,
        status: 1
    }
    //删除人员
    if (user.data_id) {
        param.id = user.data_id;
        param.status = 2;
    }
    return await api.contract.SaveConstructionUser(param)
}

//删除人员
async function deleteUser(item, user) {
    if (is_save.value) {
        return;
    }
    is_save.value = true;
    let res = await userChange(item, user)
    if (res?.data?.state == 1) {
        Message({message: '删除成功!', type: 'success'});
        emits('refresh')
    }
    is_save.value = false;
    await getList();
}

//选人
async function chooseUsers(item) {
    if (is_save.value) {
        return;
    }
    // 建设单位未保存时还没有 id，不能建立人员绑定关系
    if (!item?.id) {
        Message({message: '请先保存建设单位后再选择负责人!', type: 'warning'});
        return;
    }
    await peoplePicker.peoplePicker(item.users.map(u => u.userid), async (res) => {
        is_save.value = true;
        let users = (res?.users || []).map(u => {
            return {
                ...u,
                userid: u.emplId || u.userid,
                nickname: u.name || u.nickname,
            }
        })
        let selected_userids = users.map(u => `${u.userid}`);
        let old_users_map = {};
        item.users.forEach(u => {
            old_users_map[`${u.userid}`] = u;
        })
        let delete_users = item.users.filter(a => !selected_userids.includes(`${a.userid}`))
        let has_notify = false;//是否有保存失败的
        let notifyError = (res) => {
            if (res?.data?.state == 0 && !has_notify) {
                has_notify = true;
            }
            return res?.data?.state == 1;
        }
        // 先删除当前建设单位中被取消选择的负责人
        if (delete_users.length) {
            for (let u of delete_users) {
                let res = await userChange(item, u)
                notifyError(res)
            }
        }
        // 每个人只能绑定一个建设单位：先删掉其他建设单位中的旧绑定，再添加到当前建设单位
        if (users.length) {
            for (let u of users) {
                let old_user_info = old_users_map[`${u.userid}`];//当前建设单位是否已存在
                // 找出这个人当前挂载的其他建设单位，后面需要先清理掉
                let other_bind_list = developer_list.value
                    .filter(a => a.id !== item.id)
                    .map(a => {
                        let old_bind_user = (a.users || []).find(b => `${b.userid}` === `${u.userid}`);
                        if (!old_bind_user) {
                            return null;
                        }
                        return {
                            item: a,
                            user: old_bind_user
                        }
                    })
                    .filter(Boolean);
                let can_add_current = true;
                if (other_bind_list.length) {
                    for (let bind_info of other_bind_list) {
                        let res = await userChange(bind_info.item, bind_info.user)
                        let success = notifyError(res)
                        // 旧绑定删除失败时，不继续新增到当前建设单位，避免同一人同时挂在多个单位下
                        if (!success) {
                            can_add_current = false;
                        }
                    }
                }
                if (!old_user_info && can_add_current) {
                    let res = await userChange(item, u)
                    notifyError(res)
                }
            }
        }
        is_save.value = false;
        if (!has_notify) {
            Message({message: '保存成功!', type: 'success'});
        }
        await getList();
        emits('refresh')
    }, true);
}

//删除
function deleteItem(item) {
    MessageBox.confirm(
        '确定要删除该建设单位吗?',
        '提示',
    ).then(async () => {
        let param = {
            id: item.id,
            construction_unit: item.construction_unit,
            status: 2
        }
        let res = await api.contract.SaveConstruction(param)
        if (res?.data?.state == 1) {
            Message({message: '删除成功!', type: 'success'});
            emits('refresh')
        }
        await getList();
    })
}

//获取列表
async function getList() {
    is_save.value = false;
    let res = await api.contract.GetConstruction()
    let list = []
    if (res.data?.data) {
        list = res.data.data.construction || [];
        let user_info = res.data.data.user_info || {};
        let user_list = res.data.data.construction_users || [];
        list.forEach(item => {
            item.is_edit = false;
            item.edit_name = '';
            item.users = user_list.filter(a => a.construction_id == item.id).map(a => {
                let u = user_info[a.userid] || {};
                u.data_id = a.id;
                u.userid = a.userid;
                return u;
            })
        })
    }
    developer_list.value = list;
    syncCurrentUserContractInfoByList();
}

//关闭弹窗
function close() {
    emits('update:showDeveloper', false)
}

/**
 * 初始化
 */
watch(() => props.showDeveloper, (n, o) => {
    if (n) {
        show.value = true;
        getList();
    }
})
</script>

<style scoped lang="less">
.dialog_content {
    min-height: 200px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: column;

    .list {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        box-sizing: border-box;
        padding: 0 20px;

        .item {
            padding: 15px 25px 10px 25px;
            box-sizing: border-box;
            border: 1px dashed #ccc;
            margin-top: 10px;
            border-radius: 3px;
            position: relative;
            transition: border-color .2s;

            .item_row {
                display: flex;
                margin-bottom: 6px;

                .label {
                    line-height: 32px;
                    flex-shrink: 0;
                    width: 80px;
                    color: #666;
                }

                .value {
                    flex:1;
                    min-width: 0;
                }

                .name {
                    line-height: 20px;
                    padding-top: 6px;

                    .edit_icon {
                        color: #3396fb;
                        font-size: 16px;
                        margin-left: 8px;
                        cursor: pointer;
                        transition: opacity .2s;

                        &:hover{
                            opacity: .7;
                        }
                    }
                }

                .users {
                    display: flex;
                    flex-wrap: wrap;

                    .nickname {
                        display: flex;
                        align-items: center;
                        height: 32px;
                        margin: 0 5px 5px 0;
                        background-color: #ecf5ff;
                        border: 1px solid #d9ecff;
                        padding: 0 6px;
                        line-height: 30px;
                        box-sizing: border-box;
                        white-space: nowrap;
                        flex-shrink: 0;
                        border-radius: 4px;

                        .text, .del_user {
                            color: #409eff;
                            font-size: 12px;
                        }

                        .del_user {
                            width: 14px;
                            height: 14px;
                            border-radius: 100%;
                            color: #409eff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 10px;
                            margin: -3px 0 0 3px;
                            cursor: pointer;
                            transition: all .2s;

                            &:hover {
                                background: #3396fb;
                                color: #fff;
                            }
                        }
                    }

                    .add_btn {
                        flex-shrink: 0;
                        padding-top: 2px;
                        margin-bottom: 5px;
                    }
                }
            }

            .delete_icon {
                position: absolute;
                bottom: 1px;
                right: 1px;
                background: #ec4343;
                color: #fff;
                font-size: 12px;
                width: 20px;
                height: 20px;
                border-radius: 3px;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: opacity .2s;
                opacity: 0;
                cursor: pointer;

                &:hover {
                    opacity: .7!important;
                }
            }

            &:hover {
                border-color: #3396fb;

                .delete_icon {
                    opacity: 1;
                }
            }
        }
    }

    .add_item {
        margin: 10px 20px 0 20px;
        display: flex;
        align-items: center;
        line-height: 32px;
        justify-content: center;
        box-sizing: border-box;
        border: 1px dashed #ccc;
        border-radius: 3px;
        cursor: pointer;
        transition: all .2s;
        font-size: 13px;
        color: #666;

        .icon {
            margin: 2px 4px 0 0;
        }

        &:hover {
            border-color: #3396fb;
            color: #3396fb;
        }
    }
}
</style>
